import { useMemo } from "react";
import {
  calcBestYearlyBf,
  calcBestYearlyBudgetAccuracy,
  calcBiggestSingleSales,
  calcBestCustomers,
} from "@/lib/dashboard-halloffame-calc";
import { useSalesDashboardData } from "@/hooks/use-sales-dashboard-data";
import { HallOfFamePanel } from "./HallOfFamePanel";

/**
 * F3 Hall of Fame container. All-time records — deliberately ignores the period
 * and person filters (historical leaderboard). Pulls data once and delegates to
 * dashboard-halloffame-calc.
 */
export function SalesHallOfFame() {
  const { projects, owners, people, projectMeta, customerMeta, isLoading } = useSalesDashboardData();

  const nameMap = useMemo(() => new Map(people.map((p) => [p.userId, p.name])), [people]);
  const nameOf = (id: string) => nameMap.get(id) ?? "Ukjent";
  const customerNameOf = (id: string) => customerMeta.get(id) ?? "Ukjent kunde";
  const projectMetaOf = (id: string) => projectMeta.get(id);

  return (
    <HallOfFamePanel
      bestYearlyBf={calcBestYearlyBf(projects, owners)}
      bestAccuracy={calcBestYearlyBudgetAccuracy(projects, owners)}
      biggestSales={calcBiggestSingleSales(projects)}
      bestCustomers={calcBestCustomers(projects)}
      nameOf={nameOf}
      customerNameOf={customerNameOf}
      projectMetaOf={projectMetaOf}
      isLoading={isLoading}
    />
  );
}
